// ローディング判定
jQuery(window).on("load", function() {
  jQuery("body").attr("data-loading", "true");
});

jQuery(function() {
  // スクロール判定
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let mvHeight = jQuery(".mv").height();
    let documentHeight = jQuery(document).height();

    if (1 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }
  });

  jQuery(".g-nav-child-link").on("click", function(e) {
    let drawer = jQuery(".js-drawer");
    let targetClass = jQuery(drawer).attr("data-target");
    let ariaControls = jQuery(drawer).attr("aria-controls");

    jQuery("." + targetClass).toggleClass("is-checked");
    jQuery(body).toggleClass("is-checked");
    if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
      jQuery("#" + ariaControls).attr("aria-hidden", "false");
    } else {
      jQuery("#" + ariaControls).attr("aria-hidden", "ture");
    }

    if (jQuery(drawer).attr("aria-expanded") === "true") {
      jQuery(drawer).attr("aria-expanded", "false");
    } else {
      jQuery(drawer).attr("aria-expanded", "ture");
    }

    /*     jQuery(this).toggleClass("active");
    jQuery(this)
      .closest(".menu-second")
      .slideToggle();
    jQuery(this)
      .not(jQuery(this).closest(".g-nav-item.child"))
      .children(".menu-second")
      .slideUp();
    jQuery(this)
      .not(jQuery(this).hasClass(".active"))
      .toggleClass("active"); */
  });
  /*   } */

  /* ドロワー */
  function closeDrawer() {
    // 閉じるクラス処理
    jQuery(".drawer-bg").removeClass("is-checked");
    jQuery(".drawer-content").removeClass("is-checked");
    jQuery(".drawer-icon").removeClass("is-checked");
    jQuery("body").removeClass("is-checked");

    // aria属性も閉じる状態に
    jQuery(".drawer-icon").attr("aria-expanded", "false");
    jQuery(".drawer-content").attr("aria-hidden", "true");
  }

  jQuery(".js-drawer").on("click", function(e) {
    e.preventDefault();
    console.log('oo');

    let targetClass = jQuery(this).attr("data-target");
    let ariaControls = jQuery(this).attr("aria-controls");

    jQuery("." + targetClass).toggleClass("is-checked");
    jQuery("body").toggleClass("is-checked");

    if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
      jQuery("#" + ariaControls).attr("aria-hidden", "false");
    } else {
      jQuery("#" + ariaControls).attr("aria-hidden", "true");
    }

    if (jQuery(this).attr("aria-expanded") === "true") {
      jQuery(this).attr("aria-expanded", "false");
    } else {
      jQuery(this).attr("aria-expanded", "true");
    }

    return false;
  });

  // ★ .drawer-content 内のリンククリックでメニューを閉じる
  jQuery(".drawer-content a").on("click", function(e) {
    closeDrawer();
  });

  jQuery(".sp-btn").on("click", function() {
    jQuery(this)
      .next()
      .slideToggle();
  });
});


(function($){

  // ::before／::after の高さを取る共通関数
  function getPseudoHeight($el, which = 'before'){
    const pseudo = getComputedStyle($el[0], `::${which}`);
    const h = parseFloat(pseudo.height);
    return isNaN(h) ? 0 : h;
  }

  // .triangle_before / .triangle_after クラスで分岐
  function getTriangleOffset($target){
    if (!$target.length) return 0;
    if ($target.hasClass('triangle_after')) {
      return getPseudoHeight($target, 'after');
    }
    return getPseudoHeight($target, 'before');
  }

  // ✅ header の状態も考慮してオフセットを計算
  function calcOffset($target){
    if (!$target.length) return null;

    const $header = $('header');
    let headerH = 0;

    // body[data-scroll="true"] のときに高さが変わる前提
    if ($('body').attr('data-scroll') === 'true') {
      headerH = parseFloat($header.innerHeight()) || 0;
    } else {
      headerH = parseFloat($header.innerHeight()) || 0;
    }

    let top = $target.offset().top;
    let adjust = headerH;

    if ($target.hasClass('js-anchor_link')) {
      adjust += getTriangleOffset($target);
    }

    return top - adjust;
  }

  function scrollToHash(hash, animate){
    const $t = $(hash === '#' ? 'html' : hash);
    const pos = calcOffset($t);
    if (pos == null) return;

    if (animate) {
      $('html, body').stop().animate({ scrollTop: pos }, 400, 'swing');
    } else {
      $('html, body').scrollTop(pos);
    }
  }

  // ----------------------------
  // イベント登録部分
  // ----------------------------

  // スムーススクロール
  $(document).on('click', 'a[href^="#"]:not(.no_smooth)', function(e){
    const hash = this.hash || $(this).attr('href');
    if (!hash || hash === '#') return;
    e.preventDefault();
    scrollToHash(hash, true);
  });

  // ページ直リンク対応
  $(window).on('load', function(){
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (location.hash) {
      setTimeout(() => scrollToHash(location.hash, false), 150);
      setTimeout(() => scrollToHash(location.hash, false), 400);
    }
  });

  // hashchange 対応
  $(window).on('hashchange', function(){
    if (location.hash) scrollToHash(location.hash, true);
  });

})(jQuery);



jQuery(function() {
  // aimation呼び出し
  if (jQuery(".js-scroll-trigger").length) {
    scrollAnimation();
  }

  // aimation関数
  function scrollAnimation() {
    jQuery(window).scroll(function() {
      jQuery(".js-scroll-trigger").each(function() {
        let position = jQuery(this).offset().top,
          scroll = jQuery(window).scrollTop(),
          windowHeight = jQuery(window).height();

        if (scroll > position - windowHeight + 200) {
          jQuery(this).addClass("active");
        }
      });
    });
  }
  jQuery(window).trigger("scroll");
});

//wait
/* jQuery(function() {
  "use waits";

  var dialog = document.getElementById("dialog");
  var waits = document.getElementsByClassName("js-wait");
  var cancel = document.getElementById("cancel");
  var scrollpos;

  if (waits) {
    for (let i = 0; i < waits.length; i++) {
      waits[i].addEventListener(
        "click",
        function() {
          dialog.style.visibility = "visible";
          dialog.style.opacity = 1;
          //scrollpos = jQuery(window).scrollTop();
          jQuery("body").addClass("fixed");
          //.css({ overflow: hidden });
        },
        false
      );
    }

    cancel.addEventListener("click", function() {
      jQuery("body").removeClass("fixed");
      //.css({ overflow: auto });
      //window.scrollTo(0, scrollpos);
      dialog.style.visibility = "hidden";
      dialog.style.opacity = 0;
    });
  }
}); */

if (window.matchMedia("(min-width: 769px)").matches) {
  /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
}
var _window = jQuery(window),
  _header = jQuery("header"),
  heroBottom;

_window.on("scroll", function() {
  heroBottom1 = jQuery(".mv").height() - 120;
  heroBottom2 = jQuery(".header-logo").height();
  heroBottom = heroBottom1 - heroBottom2;
  if (_window.scrollTop() > heroBottom1) {
    _header.addClass("transform");
  } else {
    _header.removeClass("transform");
  }
});
_window.trigger("scroll");



jQuery(function() {
  jQuery(".qa-item-ttl").each(function() {
    jQuery(this).on("click", function() {
      jQuery(this).toggleClass("on");
      jQuery(this)
        .next(".qa-item-content")
        .slideToggle();
      return false;
    });
  });
});

jQuery(document).ready(function() {
  // /jQuery(".floating").hide(); //ボタンを非表示にする
/*   jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(window).scrollTop(); // スクロール上部の位置
    let headerHeight = jQuery("header").innerHeight();

    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").outerHeight(true); //止めたい位置の高さ(今回はfooter)
    stopHeight = footHeight;

    bottomHeight = footHeight;

    if (window.matchMedia("(min-width: 751px)").matches) {
      if (scrollHeight - scrollPosition <= stopHeight) {
        //ドキュメントの高さと現在地の差がfooterの高さ以下の時
        jQuery(".floating").css({
          position: "absolute", //pisitionをabsoluteに変更
          bottom: bottomHeight
        });
      } else {
        //それ以外の場合は
        jQuery(".floating").css({
          position: "fixed", //固定表示
          bottom: "0px"
        });
      }
    }

    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").innerHeight(); //止めたい位置の高さ(今回はfooter)
    stopHeight = footHeight;
  }); */
});



